import '../content-marketing/content-marketing-web-component';
import '../native/native-web-component';

export function setupCustomElements(id: string, component: any) {
    if (!customElements.get(id)) {
        customElements.define(id, component);
    }
}
